/**
 * Extra Life child theme scripts.
 *
 * Entry point bundled to dist/js/style.min.js (npm run build:js).
 */

import './pixel-jump.js';
import './tools-resources-all-filter.js';

// Update submenu width for buttons in the main menu.
jQuery(document).ready(function($) {
	function updateSubmenuWidth() {
		const $menu = $('.menu-primary-container > .menu');

		if(!$menu.length) {
			return;
		}

		if($(window).width() >= 1100) {
			const mainMenuWidth = $menu.outerWidth();
			let buttonsWidth = 0;

			$menu.children('li[class*="button--"]').each(function() {
				buttonsWidth += $(this).outerWidth();
			} );

			$menu.find('.sub-menu').css('width', mainMenuWidth - buttonsWidth + 'px');
		} else{
			$menu.find('.sub-menu').css('width', 'auto');
		}
	}

	updateSubmenuWidth();

	let resizeTimer;
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(updateSubmenuWidth, 100);
	});
});
